<template>
  <Modal @close="close">
    <div class="p-modal__content__header">
      {{ headerLabel }}
    </div>
    <div class="p-modal__content__body">
      <template v-if="!loading">
        <div class="c-grid">
          <div class="c-grid__items">
            <div v-for="(storeName, index) in storeNames" :key="`storeName_${index}`" class="item c-grid__item__s__12">
              {{ storeName }}
            </div>
          </div>
        </div>
      </template>
      <KkLoading v-else />
    </div>
    <div class="p-modal__content__footer">
      <div class="c-button c-button--right">
        <div class="js-close" />
        <button
          class="c-button__item c-button__item--outline-cancel"
          @click="close"
          v-text="$t('labels.close')"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '../Modal.vue'
import { KkLoading } from '../base'

export default {
  name: 'StoresModal',
  components: {
    KkLoading,
    Modal
  },
  props: {
    headerLabel: {
      type: String,
      required: true,
    },
    storeNames: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  methods: {
    close() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="scss" scoped>
.item {
  padding: 0 12px 12px;
}
</style>
